import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div>
                <footer className="text-center p-2 mt-4">
                    All right reserved 2021 
                </footer>
            </div>
        );
    }
}

export default Footer;